'use strict';

module.exports = {
    campaignModel: 'campaignModel',
    subCampaignsModel: 'subCampaignsModel',
    startDatesModel: 'startDatesModel',
};
